import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',

    '& .menu-areas': {
      marginLeft: 'auto',
      marginRight: theme.spacing(1),
      '&-btn': {
        padding: theme.spacing(0, 1, 0, 2),
        background: theme.palette.custom.surface[2],
        height: theme.spacing(9 / 2),
        borderRadius: theme.spacing(9 / 2 / 2),
        minWidth: theme.spacing(20),

        '&-text': {
          color: theme.palette.text.secondary,
          flexGrow: 1,
          textAlign: 'left',
        },
        '&-icon': {
          color: theme.palette.text.hint,
          marginLeft: theme.spacing(2),
        },

        '&:hover': {
          background: theme.palette.custom.surface[3],
        },
      },
    },
    '& .btn-back': {
      '&-container': {
        marginLeft: theme.spacing(1),
      },
      '&-text': {
        marginLeft: theme.spacing(1 / 2),
        color: theme.palette.text.hint,
      },
    },
  },
  dropDownAreas: {
    '& .menu-areas-dropdown': {
      '&-label': {
        color: theme.palette.text.hint,
        width: theme.spacing(25),
      },
    },
  },
}));

export default styles;
